import { render } from "./PerformanceReviewView.vue?vue&type=template&id=32151996"
import script from "./PerformanceReviewView.vue?vue&type=script&lang=js"
export * from "./PerformanceReviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__